import { z } from 'zod';

import { TransitConsignmentItemSchema } from './TransitGoodsItemSchema';
import {
  ConsignorOrConsigneeOrCarrierSchema,
  optionalBoolean,
  optionalString,
  PlaceOfLoadingOrUnloadingSchema,
  TransitActiveBorderTransportMeansSchema,
  TransitAdditionalSupplyChainActorSchema,
  TransitCountryOfRoutingOfConsignmentSchema,
  TransitDepartureTransportMeansSchema,
  TransitDocumentSchema,
  TransitLocationOfGoodsSchema,
  TransitTransportEquipmentSchema,
  TransportChargesSchema,
} from './utils';

export const TransitHouseConsignmentBatchSchema = z.object({
  id: z.any().optional().nullable(),
  name: optionalString(),
});

export const TransitHouseConsignmentSchema = z.object({
  sequenceNumber: optionalString(),
  countryOfDispatch: optionalString(),
  countryOfDestination: optionalString(),
  grossMass: optionalString(),
  referenceNumberUCR: optionalString(),
  releaseType: optionalString(),
  receivedFromUnloadPermission: optionalBoolean(),
  isMissing: optionalBoolean(),
  Consignor: ConsignorOrConsigneeOrCarrierSchema.optional(),
  Consignee: ConsignorOrConsigneeOrCarrierSchema.optional(),
  AdditionalSupplyChainActor: z.array(TransitAdditionalSupplyChainActorSchema).optional(),
  DepartureTransportMeans: z.array(TransitDepartureTransportMeansSchema).optional(),
  PreviousDocument: z.array(TransitDocumentSchema).optional(),
  SupportingDocument: z.array(TransitDocumentSchema).optional(),
  TransportDocument: z.array(TransitDocumentSchema).optional(),
  AdditionalReference: z.array(TransitDocumentSchema).optional(),
  AdditionalInformation: z.array(TransitDocumentSchema).optional(),
  TransportCharges: TransportChargesSchema.optional(),
  ConsignmentItem: z.array(TransitConsignmentItemSchema).optional(),
  batches: z.array(TransitHouseConsignmentBatchSchema).optional(),
});
export type TransitHouseConsignment = z.infer<typeof TransitHouseConsignmentSchema>;

export const TransitConsignmentSchema = z.object({
  countryOfDispatch: optionalString(),
  countryOfDestination: optionalString(),
  containerIndicator: optionalString(),
  inlandModeOfTransport: optionalString(),
  modeOfTransportAtTheBorder: optionalString(),
  grossMass: optionalString(),
  totalNumberOfPackages: optionalString(),
  totalQuantity: optionalString(),
  totalNumberOfSeals: optionalString(),
  referenceNumberUCR: optionalString(),
  Carrier: ConsignorOrConsigneeOrCarrierSchema.optional(),
  Consignor: ConsignorOrConsigneeOrCarrierSchema.optional(),
  Consignee: ConsignorOrConsigneeOrCarrierSchema.optional(),
  ConsigneeActual: ConsignorOrConsigneeOrCarrierSchema.optional(),
  AdditionalSupplyChainActor: z.array(TransitAdditionalSupplyChainActorSchema).optional(),
  TransportEquipment: z.array(TransitTransportEquipmentSchema).optional(),
  LocationOfGoods: TransitLocationOfGoodsSchema.optional(),
  DepartureTransportMeans: z.array(TransitDepartureTransportMeansSchema).optional(),
  CountryOfRoutingOfConsignment: z.array(TransitCountryOfRoutingOfConsignmentSchema).optional(),
  ActiveBorderTransportMeans: z.array(TransitActiveBorderTransportMeansSchema).optional(),
  PlaceOfLoading: PlaceOfLoadingOrUnloadingSchema.optional(),
  PlaceOfUnloading: PlaceOfLoadingOrUnloadingSchema.optional(),
  PreviousDocument: z.array(TransitDocumentSchema).optional(),
  SupportingDocument: z.array(TransitDocumentSchema).optional(),
  TransportDocument: z.array(TransitDocumentSchema).optional(),
  AdditionalReference: z.array(TransitDocumentSchema).optional(),
  AdditionalInformation: z.array(TransitDocumentSchema).optional(),
  TransportCharges: TransportChargesSchema.optional(),
  HouseConsignment: z.array(TransitHouseConsignmentSchema).optional(),
});
export type TransitConsignment = z.infer<typeof TransitConsignmentSchema>;
